import { render } from "./ClientEdit.vue?vue&type=template&id=21b6c5c9&scoped=true"
import script from "./ClientEdit.vue?vue&type=script&lang=js"
export * from "./ClientEdit.vue?vue&type=script&lang=js"

import "./ClientEdit.vue?vue&type=style&index=0&id=21b6c5c9&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/translation_system/translation_system/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b6c5c9"]])

export default __exports__